import { extend, localize, setInteractionMode } from 'vee-validate'
import { email, required, image, min, confirmed, max, regex, integer } from 'vee-validate/dist/rules'

setInteractionMode('lazy')

extend('required', required)
extend('email', email)
extend('image', image)
extend('min', min)
extend('max', max)
extend('regex', regex)
extend('confirmed', confirmed)
extend('integer', integer)

localize('de')
